import {
  BigDollarInput,
  BigDollarInputProps,
} from "@/components/BigDollarInput/BigDollarInput";
import { useIsModelReadOnly } from "@/hooks/useFinancialDeckPermissions";
import { SidebarInputProps } from "./types";

export const InputDollar = ({
  labelWidth = 181,
  ...props
}: SidebarInputProps & BigDollarInputProps) => {
  const [isModelShared] = useIsModelReadOnly();

  return (
    <BigDollarInput
      leftSectionWidth={22}
      disabled={isModelShared}
      size="sm"
      styles={{
        root: { display: "flex", alignItems: "center" },
        label: { width: labelWidth },
        wrapper: { flex: 1 },
      }}
      {...props}
    />
  );
};
